import React, { useCallback } from "react";
import RemoveStep from "../RemoveStep";
import DraggableField from "./DraggableField";

const WorkflowSteps = ({
  edit,
  register,
  errors,
  fields,
  remove,
  close,
  control,
  setValue,
}) => {
  const [openRemoveStep, setOpenRemoveStep] = React.useState(false);
  const [currentStep, setCurrentStep] = React.useState();

  const handleSetOpenRemoveStep = useCallback((value) => {
    setOpenRemoveStep(value);
  }, []);
  return (
    <>
      {openRemoveStep && (
        <RemoveStep
          close={close}
          currentStep={currentStep}
          fields={fields}
          showRemoveSteps={openRemoveStep}
          setShowRemoveSteps={handleSetOpenRemoveStep}
        />
      )}
      {fields &&
        fields.map((field, index) => (
          <DraggableField
            key={`draggable-field-${index}`}
            field={field}
            control={control}
            index={index}
            remove={remove}
            edit={edit}
            setOpenRemoveStep={handleSetOpenRemoveStep}
            register={register}
            setValue={setValue}
            setCurrentStep={setCurrentStep}
            errors={errors}
          />
        ))}
    </>
  );
};

export default React.memo(WorkflowSteps);
